// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Legacy redirect route for /items/{itemKey}/audit.
 * Redirects to /catalog/items/{itemKey}/audit.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/items/$itemKey/audit')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/catalog/items/$itemKey/audit',
      params: { itemKey: params.itemKey },
      search: true,
    });
  },
});
